<template>
    <div class="page_content stream_planner_view">

      <div class="row page-heading">
        <div class="col-7 input module_heading">
          <span class="module_icon icon-stream"></span>
          <label class="head_txt module_type_name"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{stream.title}}</label>
        </div>
        <div class="col-5 right-container">
          <stream-header :uuid="uuid"
                         active="category">
          </stream-header>
        </div>
      </div>

	  <div class="page-content">
		    <stream-menu :uuid="uuid" active="planner"></stream-menu>
  			<planner :uuid="uuid" :academic-year="academicYear"></planner>
	   </div>

  </div>
</template>

<script>
import '../../../assets/module/css/stream/streamPlanner.min.css'
import { mapState, mapActions } from 'vuex'
import StreamMenu from './StreamMenu'
import StreamHeader from './StreamHeader'
import Planner from './Planner'

export default {
  name: 'streamPlanner',
  props: ['uuid', 'academicYear'],
  components: {
    StreamMenu,
    StreamHeader,
    Planner
  },
  data: () => {
    return {
      userrole: localStorage.getItem('userrole'),
      academicYearDefault: '2020-2021'
    }
  },

  mounted () {
    this.loadStream()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadStreamDetail',
      'loadLogDashboardActivity',
      'loadStreamPlannerView',
      'updateSelectedStream'
    ]),

    loadStream () {
      this.loadLogDashboardActivity({action: 'viewStreamPlannerView', page: 'streamPlannerView', link: '', entityUuid: this.uuid})
      this.loadStreamDetail(this.uuid)
      this.updateSelectedStream({streamUuid: this.uuid})
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream
    }),
    advisorTitle () {
      if (this.userrole === 'Advisor') {
        return '' + this.stream.ownerName + ''
      } else {
        return ''
      }
    }
  },

  watch: {
  }
}
</script>
<style>
.jumbotron {
  background: #fffff;
}
.text-center {
  text-align: center;
}
.bg-gray{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamPlanner.vue